/**
 * Bundle builder remake
 * The code extends the default functions of the biscuits app using API and JS.
 */

class BundleBuilderRemake {
  constructor() {
    this.bundleForm = null;
    this.footer = null;
    this.marker = null;
    document.addEventListener("BiscuitsBundleForm:ready", (event) => {
      this.bundleForm = event.target;
      this.init();
    });
  }

  init() {
    this.footer = document.querySelector('[data-biscuits-position="footer"]');
    if (!this.footer) return;

    // Use the next sibling element as a marker
    this.marker = this.footer.nextElementSibling;
    if (!this.marker) return;

    this.observerFooter();
    this.moveActionsToVolumeDiscounts();

    window.addEventListener('resize', () => this.moveActionsToVolumeDiscounts());
  }

  moveActionsToVolumeDiscounts() {
    if (!this.bundleForm) return;

    const actions = this.bundleForm.querySelector('.biscuits-bundle-actions');
    const volumeDiscounts = this.bundleForm.querySelector('biscuits-bundle-volume-discounts[data-biscuits-position="footer"]');

    if (!actions || !volumeDiscounts) return;

    if (!this.originalActionsParent) {
      this.originalActionsParent = actions.parentElement;
    }

    const isDesktop = window.innerWidth >= 900;

    if (isDesktop) {
      if (!volumeDiscounts.contains(actions)) {
        volumeDiscounts.appendChild(actions);
      }
    }
    else {
      if (this.originalActionsParent) {
        this.originalActionsParent.appendChild(actions);
      }
    }
  }

  observerFooter() {
    // IntersectionObserver will watch the next sibling
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer has reached the bottom → remove shadow
            this.footer.classList.add("no-shadow");
          } else {
            // Footer is sticky → show shadow
            this.footer.classList.remove("no-shadow");
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0 // trigger as soon as marker enters viewport
      }
    );

    if (document.querySelector('.shopify-section--featured-product')) {
      observer.observe(this.marker.closest('.shopify-section--featured-product').querySelector('.Block-Type-buy_buttons'));
    }
    if (document.querySelector('.shopify-section--main-product')) {
      observer.observe(this.marker.closest('.shopify-section--main-product').querySelector('.Block-Type-buy_buttons'));
    }
  }
}

window.BundleBuilderRemake = new BundleBuilderRemake();